module.exports = __webpack_public_path__ + "img/accordion-collapsed.650871e1.svg";